// extracted by mini-css-extract-plugin
export default {"productCarousel":"O0-z"};